import { useCallback } from 'react';

import { AxiosResponse } from 'axios';
import { UseQueryResult, useQuery } from 'react-query';
import { PackageUtilizationExpectationListItem } from 'types';
import { client } from 'utils/api-client';

const PACKAGE_UTILIZATION_EXPECTATIONS_QUERY_KEY = 'package-utilization-expectations-list';

function useExpectations({
  enabled = true,
}: {
  enabled?: boolean;
}): UseQueryResult<AxiosResponse<PackageUtilizationExpectationListItem[]>> {
  const fetchPackageUtilizationExpectations = useCallback(() => {
    return client.get('/package-utilization-expectations');
  }, []);

  return useQuery({
    queryKey: [PACKAGE_UTILIZATION_EXPECTATIONS_QUERY_KEY],
    queryFn: fetchPackageUtilizationExpectations,
    enabled,
  });
}

function useExistsAtLeastOneExpectation({ enabled = true }: { enabled?: boolean }): UseQueryResult<boolean> {
  const fetchPackageUtilizationExpectations = useCallback(() => {
    return client.get('/package-utilization-expectations');
  }, []);

  return useQuery({
    queryKey: [PACKAGE_UTILIZATION_EXPECTATIONS_QUERY_KEY],
    queryFn: fetchPackageUtilizationExpectations,
    enabled,
    select: data => data.data.length > 0,
  });
}

export default useExpectations;
export { useExistsAtLeastOneExpectation, PACKAGE_UTILIZATION_EXPECTATIONS_QUERY_KEY };
